// extracted by mini-css-extract-plugin
export default {"text":"Error_text__O-uey","icon":"Error_icon__pkI3O","response":"Error_response__NdmoA","buttons":"Error_buttons__7Y13Z"};